import AgeGate from "@/components/AgeGate"
import AvisoComp from "@/components/AvisoComp"
import CookiesComp from "@/components/CookiesComp"
import TermsComp from "@/components/TermsComp"
import Vue from "vue";
import VueObserveVisibility from "vue-observe-visibility";
import VueRouter from "vue-router";

Vue.use(VueRouter);
Vue.use(VueObserveVisibility);

const routes = [
    {
        path: "/",
        name: "agegate",
        component: AgeGate,
    },
    {
        path: "/politics",
        name: "avisoComp",
        component: AvisoComp,
    },
    {
        path: "/cookies",
        name: "cookiesComp",
        component: CookiesComp,
    },
    {
        path: "/tycos",
        name: "termsComp",
        component: TermsComp,
    }, 

]

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

export default router;
